(() => {
  'use strict';
  const rootSelector = '[data-np-article-erospain-slider]';
  const activeClass = 'np-article-erospain-c-96879611650f';
  function setup(scope) {
    const roots = [...scope.querySelectorAll(rootSelector)];
    if (scope.matches?.(rootSelector)) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.nativeSliderReady === 'true') return;
      const config = JSON.parse(root.getAttribute('data-native-slider-config'));
      const track = root.querySelector('[data-native-slider-track]');
      const originals = [...track.children].filter((node) => node.hasAttribute('data-native-slide'));
      const pagination = root.querySelector('[data-native-slider-pagination]');
      if (originals.length !== 9 || !config.loop || config.autoPlayDelay !== 3000) return;
      root.dataset.nativeSliderReady = 'true';
      const count = originals.length;
      let logicalIndex = 0;
      let settleTimer;
      let autoplay;
      let layoutFrame;
      let pendingTargetLeft = null;
      let pendingManual = false;
      const currentMode = () => window.innerWidth >= 1199.5 ? 'all' : window.innerWidth >= 1024.5 ? 'laptop' : window.innerWidth >= 767.5 ? 'tablet' : 'mobile';
      const pageCount = () => Math.ceil((count - config.slidesToShow[currentMode()]) / config.slidesToScroll[currentMode()]) + 1;
      const normalize = (index) => ((index % pageCount()) + pageCount()) % pageCount();
      function offset(index) {
        const mode = currentMode();
        const slide = originals[Math.min(index * config.slidesToScroll[mode], count - config.slidesToShow[mode])];
        const padding = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        const paddingPixels = getComputedStyle(track).scrollPaddingLeft.endsWith('%') ? padding * track.clientWidth / 100 : padding;
        const left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - paddingPixels;
        return Math.max(0, Math.min(left, track.scrollWidth - track.clientWidth));
      }
      function updatePagination() {
        [...pagination.children].forEach((button, index) => {
          const active = normalize(logicalIndex) === index;
          button.classList.toggle(activeClass, active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
      function releasePending() {
        pendingTargetLeft = null;
        pendingManual = false;
        clearTimeout(settleTimer);
      }
      function move(index, smooth = true, manual = false) {
        clearTimeout(settleTimer);
        logicalIndex = normalize(index);
        const left = offset(logicalIndex);
        pendingTargetLeft = Math.abs(track.scrollLeft - left) > 1 ? left : null;
        pendingManual = manual && pendingTargetLeft !== null;
        if (!smooth) track.style.scrollBehavior = 'auto';
        track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        if (!smooth) track.style.removeProperty('scroll-behavior');
        updatePagination();
      }
      function settle() {
        if (pendingTargetLeft !== null) {
          if (Math.abs(track.scrollLeft - pendingTargetLeft) > 1) return;
          const restartAfterArrival = pendingManual;
          pendingTargetLeft = null;
          pendingManual = false;
          if (restartAfterArrival) startAutoplay();
        }
        let nearest = 0;
        let distance = Infinity;
        for (let index = 0; index < pageCount(); index += 1) {
          const candidateDistance = Math.abs(offset(index) - track.scrollLeft);
          if (candidateDistance < distance) { distance = candidateDistance; nearest = index; }
        }
        logicalIndex = nearest;
        updatePagination();
      }
      function advance(direction, manual = false) {
        move(logicalIndex + direction, true, manual);
      }
      function startAutoplay() {
        clearInterval(autoplay);
        if (config.autoPlay) autoplay = setInterval(() => {
          if (!root.isConnected) { clearInterval(autoplay); return; }
          if (pendingTargetLeft !== null) {
            if (Math.abs(track.scrollLeft - pendingTargetLeft) > 1) return;
            const restartAfterArrival = pendingManual;
            pendingTargetLeft = null;
            pendingManual = false;
            if (restartAfterArrival) { startAutoplay(); return; }
          }
          advance(1);
        }, config.autoPlayDelay);
      }
      originals.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${index + 1} of ${count}`);
      });
      function buildPagination() {
        if (pagination.children.length === pageCount()) return;
        pagination.replaceChildren();
        for (let index = 0; index < pageCount(); index += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `Go to slide ${index * config.slidesToScroll[currentMode()] + 1}`);
          button.addEventListener('click', () => { move(index, true, true); startAutoplay(); });
          pagination.append(button);
        }
      }
      root.querySelector('[data-native-slider-prev]').addEventListener('click', () => { advance(-1, true); startAutoplay(); });
      root.querySelector('[data-native-slider-next]').addEventListener('click', () => { advance(1, true); startAutoplay(); });
      track.addEventListener('scroll', () => { clearTimeout(settleTimer); settleTimer = setTimeout(settle, 140); }, { passive: true });
      function userInterrupted(event) {
        if (event.type === 'keydown' && !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown', ' ', 'Spacebar'].includes(event.key)) return;
        if ((event.type === 'pointerdown' || event.type === 'touchstart') && event.target?.closest?.('button')) return;
        releasePending();
        settle();
        startAutoplay();
      }
      ['wheel', 'pointerdown', 'touchstart', 'keydown'].forEach((type) => track.addEventListener(type, userInterrupted, { passive: true }));
      function layout() {
        cancelAnimationFrame(layoutFrame);
        layoutFrame = requestAnimationFrame(() => {
          if (!root.isConnected) return;
          if (config.maxHeight) {
            track.style.removeProperty('height');
            const height = Math.max(...originals.map((slide) => slide.getBoundingClientRect().height));
            if (height > 0) track.style.height = `${height}px`;
          }
          buildPagination();
          const restartAfterLayout = pendingManual;
          move(Math.min(logicalIndex, pageCount() - 1), false);
          if (restartAfterLayout) startAutoplay();
        });
      }
      track.querySelectorAll('img').forEach((img) => img.addEventListener('load', layout));
      const observer = new ResizeObserver(layout);
      observer.observe(root);
      layout();
      startAutoplay();
      // The source explicitly sets pauseOnHover=false; no hover pause is installed.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  else setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
